module.exports = __webpack_public_path__ + "static/media/1.96fa4fcd.jpg";